import jsPDF from 'jspdf';
import moment from 'moment';
import { drawCabeceraLogo, drawFooterEmpresa } from './empresa_pdf';

/* Agregar imagen: addImage ( source, tipo, posicionX, posicionY, ancho, alto) */
/* addImage ( 'img.png', 'PNG', 100, 100, 50, 50) */
/* Agregar texto: text(texto, posicionX, posicionY) (se puede usar setFont, setFontSize, setTextColor, setFontType) */
/* pdf.setFontSize(20); pdf.setFont("times"); pdf.setFontType("bold"); pdf.setTextColor(255, 0, 0); */
/* A4: 210mm x 297 mm */


export default {
  methods: {
    exportPDFPresupuestoProduccion (presupuesto, renglones, empresa) {
      let pdfName = 'presupuesto_interno_'; 
      pdfName = pdfName.concat(presupuesto.id.toString().trim()); 
      /* Parametros: portrait, milimetros, A4 */
      var doc = new jsPDF('p', 'mm', 'a4');
      /* Cantidad de paginas */
      let pages = 1;

      doc.setProperties({
        title: 'Presupuesto',
        subject: 'Presupuesto',		
        author: 'Cervertti - Marketing & Eventos',
        creator: 'Cervetti'
      });

      // let fontName = 'CenturyGothic';
      // let fontBoldName = 'CenturyGothicBold';
      // let fontItalicName = 'CenturyGothicItalic';
      // let fontBoldItalicName = 'CenturyGothicBoldItalic';

      let fontName = 'Montserrat-Regular';
      let fontBoldName = 'Montserrat-Bold';
      let fontItalicName = 'Montserrat-Italic';
      let fontBoldItalicName = 'Montserrat-BoldItalic';

      /* Inicial renglones */
      let positionRenglonesY = 70;
      /* Limite para el salto de página */
      let positionMaxY = 275;
      
      /* Interlineado */
      let interlineadoOrdenes = 6;
      let interlineadoSubtrabajos = 6;
      let interlineadoRenglones = 3;

      /* Formato para alinear numeros a la derecha */
      let alignRight = {
        'align': 'right'
      }

      // console.log('drawCabecera');
      drawCabecera(doc, empresa, presupuesto, 
        fontName, fontBoldName, fontItalicName, fontBoldItalicName);
  
      /* Renglones */
      let positionY = positionRenglonesY;

      /* Titulo de los renglones */
      // doc.setTextColor(151, 148, 149);
      doc.setTextColor(60, 60, 60);
      doc.setFont(fontBoldName, 'bold');
      // doc.setFontType('normal');

      doc.text('Trabajo', 10, positionY);
      doc.text('Cantidad', 160, positionY, alignRight);
      doc.text('Costo Estimado', 200, positionY, alignRight);

      let inicial = true;
      let costoTotal = 0;


      for(let key in renglones) {
        const renglon = renglones[key];

        /* Verificamos si entra el titulo de la OT y al menos dos renglones */
        if (positionY + interlineadoOrdenes + 5 > positionMaxY) {
          /* Agregamos el footer */
          drawFooterEmpresa(doc, empresa, fontName);

          /* Agregamos una nueva pagina */
          doc.addPage();
          pages++;
          drawCabecera(doc, empresa, presupuesto, 
            fontName, fontBoldName, fontItalicName, fontBoldItalicName);
          
          positionY = positionRenglonesY;
        } else {
          if (inicial) {
            positionY += 4;
            inicial = false;
          } else {
            positionY += interlineadoOrdenes;
          }
        }

        /* Cabecera de la OT */
        doc.setFontSize(7);
        doc.setFont(fontBoldName, 'bold');
        doc.text( `${renglon.id.toString().trim()} - ${renglon.rubroTrabajo.trim()} - ${renglon.titulo.trim()}` , 10, positionY);

        doc.setFontSize(7);
        doc.setFont(fontName, 'normal');
        // doc.setFontType('normal');
        doc.text(this.$options.filters.numero(renglon.cantidad), 160, positionY, alignRight);
        doc.text(this.$options.filters.moneda(renglon.costoEstimadoTotal), 200, positionY, alignRight);
        costoTotal += parseFloat(renglon.costoEstimadoTotal);
        positionY += 2;

        /* Descripción de la OT */
        let lineasDescripcion = renglon.descripcion.split(/\r?\n/g);

        for (let linea = 0; linea < lineasDescripcion.length; linea++) {

          if (positionY + interlineadoRenglones >= positionMaxY) {
            /* Agregamos el footer */
            drawFooterEmpresa(doc, empresa, fontName);

            /* Agregamos una nueva pagina */
            doc.addPage();
            pages++;
            drawCabecera(doc, empresa, presupuesto, 
              fontName, fontBoldName, fontItalicName, fontBoldItalicName);
            
            positionY = positionRenglonesY;

            doc.setFontSize(6);
            doc.setFont(fontName, 'normal');
            // doc.setFontType('normal');
            
            doc.text('Continuación ...', 15, positionY);

            doc.setFontSize(7);

            positionY += interlineadoRenglones + 2;

          } else {
            positionY += interlineadoRenglones;
          }

          let lineaDescripcion = lineasDescripcion[linea];

          if (lineaDescripcion.length > 150) {
            // let lastSpace = lineaLongMaxima.lastIndexOf(' ');
            let lastSpace = lineaDescripcion.substring(0, 150).search(/ [^ ]*$/);
            /* Dividimos la linea en dos */
            doc.text(lineaDescripcion.substring(0, lastSpace).trim(), 15, positionY);
            positionY += interlineadoRenglones;
            doc.text(lineaDescripcion.substring(lastSpace + 1).trim(), 15, positionY);

          } else {
            doc.text(lineaDescripcion, 15, positionY);
          }
        }

        if (positionY + 5 >= positionMaxY) {
          /* Agregamos el footer */
          drawFooterEmpresa(doc, empresa, fontName);

          /* Agregamos una nueva pagina */
          doc.addPage();
          pages++;
          drawCabecera(doc, empresa, presupuesto, 
            fontName, fontBoldName, fontItalicName, fontBoldItalicName);
          
          positionY = positionRenglonesY;

        } else {
          positionY += interlineadoRenglones + 2;
        }

        /* Subtrabajos */
        if (renglon.subtrabajos) {
          if (renglon.subtrabajos.length != 0) {
            /* Subtitulo de subtrabajos */
            // positionY += (interlineadoRenglones + 2);
            doc.setFont(fontBoldName, 'bold');
            // doc.setFontType('normal');
            doc.text('Subtrabajos', 20, positionY);

            positionY += (interlineadoRenglones + 2);

            let subtrabajoInicial = true;

            renglon.subtrabajos.forEach(subtrabajo => {
              if (positionY + interlineadoSubtrabajos + 5 >= positionMaxY) {
                /* Agregamos el footer */
                drawFooterEmpresa(doc, empresa, fontName);
      
                /* Agregamos una nueva pagina */
                doc.addPage();
                pages++;
                drawCabecera(doc, empresa, presupuesto, 
                  fontName, fontBoldName, fontItalicName, fontBoldItalicName);
                
                positionY = positionRenglonesY;
      
              } else {
                if (subtrabajoInicial) {
                  positionY += 0;
                  subtrabajoInicial = false;
                } else {
                  positionY += interlineadoSubtrabajos;
                }
              }

              /* Titulo del subtrabajo */
              doc.setFontSize(7);
              doc.setFont(fontName, 'normal');
              // doc.setFontType('normal');
              doc.text(subtrabajo.articuloTipo, 20, positionY);
              doc.text(this.$options.filters.numero(subtrabajo.cantidad), 160, positionY, alignRight);
              doc.text(this.$options.filters.moneda(subtrabajo.costoTotal), 200, positionY, alignRight);
              positionY += 2;

              /* Descripción del subtrabajo */
              let lineasObservaciones = subtrabajo.observaciones.split(/\r?\n/g);

              for (let linea = 0; linea < lineasObservaciones.length; linea++) {
                if (positionY + interlineadoRenglones >= positionMaxY) {
                  /* Agregamos el footer */
                  drawFooterEmpresa(doc, empresa, fontName);
      
                  /* Agregamos una nueva pagina */
                  doc.addPage();
                  pages++;
                  drawCabecera(doc, empresa, presupuesto, 
                    fontName, fontBoldName, fontItalicName, fontBoldItalicName);
                  
                  positionY = positionRenglonesY;
                
                  // doc.setFontSize(7);
                  // doc.setFont(fontItalicName);
                  // doc.setFontType('italic');
                  doc.setFontSize(6);
                  doc.setFont(fontName, 'normal');
                  // doc.setFontType('normal');
      
                  doc.text('Continuación ...', 15, positionY);
      
                  doc.setFontSize(7);
                  // doc.setFont(fontName);
                  // doc.setFontType('normal');
            
                  positionY += interlineadoRenglones + 2;
      
                } else {
                  positionY += interlineadoRenglones;
                }

                if (lineasObservaciones[linea].length > 145) {
                  // let lastSpace = lineaLongMaxima.lastIndexOf(' ');
                  let lastSpace = lineasObservaciones[linea].substring(0, 145).search(/ [^ ]*$/);
                  /* Dividimos la linea en dos */
                  doc.text(lineasObservaciones[linea].substring(0, lastSpace).trim(), 25, positionY);
                  positionY += interlineadoRenglones;
                  doc.text(lineasObservaciones[linea].substring(lastSpace + 1).trim(), 25, positionY);

                } else {
                  doc.text(lineasObservaciones[linea], 25, positionY);
                }
              }
            })
          }
        }
      }
  
      /* Totales  */
      if (positionY + 12 >= positionMaxY) {
          /* Agregamos el footer */
          drawFooterEmpresa(doc, empresa, fontName);

          /* Agregamos una nueva pagina */
          doc.addPage();
          pages++;
          drawCabecera(doc, empresa, presupuesto, 
            fontName, fontBoldName, fontItalicName, fontBoldItalicName);
          positionY = positionRenglonesY;
      } else {
        positionY += 5;
        doc.line(10, positionY, 200, positionY);      
      }

      positionY += 5;
      doc.setFont(fontBoldItalicName, 'bolditalic');
      // doc.setFontType('normal');
      doc.text('TOTAL:', 10, positionY);
      doc.text(this.$options.filters.moneda(costoTotal, presupuesto.moneda), 200, positionY, alignRight);
      
      drawFooterEmpresa(doc, empresa, fontName);

      /* Numeramos las páginas */
      for (let index = pages - 1; index >= 0; index--) {
        doc.setPage(index + 1);
        doc.setFont(fontName, 'normal');
        doc.setFontSize(6);
        doc.setTextColor(0, 0, 0);
        let cadena = new String().concat('Página ', (index + 1).toString(), " de ", pages.toString());
        doc.text(cadena, 10, 286);
      }

      window.open(doc.output("bloburl", { filename: pdfName + '.pdf' } ));

      return;
    },
  }
}

function drawCabecera(doc, empresa, presupuesto, 
  fontName, fontBoldName, fontItalicName, fontBoldItalicName) {

  drawCabeceraLogo(doc, empresa, fontName);

  /* Titulo */
  doc.setFont(fontName, 'normal');
  doc.setFontSize(24);
  // doc.setTextColor(232, 67, 113);
  doc.setTextColor(empresa.imagenColorR || 232, empresa.imagenColorG || 67, empresa.imagenColorB || 113);
  doc.text('Presupuesto Interno', 64, 20);

  /* Datos del cliente */
  doc.setFontSize(8);
  doc.setTextColor(60, 60, 60);
  
  let positionY = 48;
  // doc.text(`Nro. Presupuesto: ${presupuesto.id.toString().trim()}`, 10, positionY);
  doc.text(`Nro. Presupuesto: ${presupuesto.presupuestoNumero.toString().trim()}`, 10, positionY);
  positionY += 4;
  doc.text(`Cliente: ${presupuesto.cliente.trim()}`, 10, positionY);
  positionY += 4;
  doc.text(`Acción: ${presupuesto.accion.trim()}`, 10, positionY);

  doc.setDrawColor(151, 148, 149); 
  doc.setLineWidth(0.3);
  doc.line(10, 62, 200, 62);
}

